import styled from '@emotion/styled'
import { Link } from 'react-router-dom'
import { useImages, useShop } from 'shop/hooks'
import { StyledHTMLElement } from 'shop/theme/types'
import { ImageTagType } from 'shop/types'

interface LogoProps {
  imageUrl: string
  url: string
}

const Brand = styled.div<StyledHTMLElement & { urlIsSame: boolean }>(
  ({ theme, urlIsSame }) => ({
    display: 'flex',
    alignItems: 'center',
    height: '70%',
    pointerEvents: urlIsSame ? 'none' : 'auto',
    [theme.mediaQueries.viewport7]: {
      height: '100%'
    }
  })
)

const StyledLink = styled(Link)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  height: '100%',
  width: '100%'
}))

const Image = styled.img(() => ({
  height: 'auto',
  maxHeight: '31px',
  width: 'auto',
  maxWidth: '100%'
}))

const Logo = ({ imageUrl, url }: LogoProps) => {
  const { partner } = useShop()
  const { getImage, handleImageError } = useImages(
    [{ imageUrl }],
    ImageTagType.Standard
  )
  const isUrlSame = `/order` + url === window.location.pathname
  return (
    <Brand urlIsSame={isUrlSame}>
      <StyledLink data-testid='nav-bar-logo-link' to={url}>
        <Image
          alt={`${partner?.name ? partner.name + ' Logo' : 'Logo'}`}
          src={getImage('auto', 100)}
          onError={handleImageError}
        />
      </StyledLink>
    </Brand>
  )
}

export default Logo
